@let segment = value() | progressBarSegment: config() : isColumnPercent() : extremes();
@let extras = config()?.extras;

@if (extras !== 'none') {
  @let valueStyles =
    config()?.valueColor !== 'alert'
      ? null
      : { color: segment.color, background: segment.color + '12' };
  <div
    class="text-13"
    [class.progress-bar-pill]="config()?.valueColor === 'alert'"
    [style]="valueStyles"
  >
    {{ value() | formatValue: valueFormat() : valueFormatOptions() }}
  </div>
}
<div class="w-full overflow-hidden rounded-4 h-8 bg-bat-complementary">
  <div
    class="h-full"
    [style.width.%]="segment.width"
    [style.background-color]="segment.color"
  ></div>
</div>
